/* eslint-disable prefer-destructuring */
export default function reducer(state = {
  staff: [],
  staff_member_relationships: {},
  personalRewards: {
    data: {
      attributes: {}
    },
    managementLink: '',
    contentUrl: ''
  },
  staffRewards: {
    stores: [],
    manageRewardsVisible: false,
    manageStore: null,
    manageRow: null,
    manageFetching: false,
    manageFetched: false,
  },
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'GET_STAFF_PENDING': {
      // Must NOT fall through to the FULFILLED block below. getStaffByOutlet
      // dispatches this with `payLoad: []` (see actions/staff.js), so
      // `action.payLoad.data` is undefined — the old fall-through left
      // `fetched: true` with `staff: undefined`, and StaffList then crashed on
      // `props.staff.forEach` during the pending phase (before the fulfilled
      // data arrived). Pending = fetching, not fetched.
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case 'GET_STAFF_REWARDS_OUTLETS_PENDING':
    case 'GET_SETTINGS_PENDING':
    case 'GET_PERSONAL_REWARDS_PENDING':
    case 'GET_STAFF_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        staff: action.payLoad.data,
      };
    }
    case 'GET_SETTINGS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        redemptions: {
          ...state.redemptions,
          settings: action.payLoad
        }

      };
    }
    case 'GET_PERSONAL_REWARDS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        personalRewards: {
          data: action.payLoad.data,
          managementLink: action.payLoad.links['check-my-balance'],
          contentUrl: action.payLoad.links['personal-rewards-page']
        },
      };
    }
    case 'GET_STAFF_REJECTED':
    case 'GET_SETTINGS_REJECTED':
    case 'GET_PERSONAL_REWARDS_REJECTED':
    case 'RESEND_STAFF_INVITATION_REJECTED': {
      return {
        ...state,
        // fetching: false,
        errors: action.payLoad
      };
    }
    case 'RESEND_STAFF_INVITATION_FULFILLED': {
      return {
        ...state,
        staffInvitationSent: true
      };
    }
    case 'SHOW_EDIT_STAFF': {
      return {
        ...state,
        removeLink: action.removeLink,
        saveLink: action.saveLink,
        staff_member_id: action.payLoad.id,
        staff_member_row: action.show,
        staff_member_status: action.status
      };
    }
    case 'REMOVE_STAFF_MEMBER_FULFILLED': {
      const newState = {
        ...state,
        staff_member_row: undefined,
        staff_member_id: undefined
      };
      newState.staff = newState.staff.filter(staff => staff.id !== action.id);
      return newState;
    }
    case 'ADD_STAFF_FULFILLED': {
      return {
        ...state,
        staff_member_relationships: action.payLoad.data.relationships
      };
    }
    case 'SAVE_STAFF_MEMBER_FULFILLED': {
      // const staff = [...state.staff];
      // const oldStaff = staff.find(item => item.id === action.payLoad.data.id);
      // if(oldStaff) {
      //   const index = staff.indexOf(oldStaff);
      //   staff.splice(index,0,action.payLoad.data);
      // } else {
      //   staff.push(action.payLoad.data);
      // }

      return {
        ...state,
        staff: [],
        staff_member_row: undefined,
        staff_member_id: undefined
      };
    }
    case 'CLEAR_EDIT_STAFF_MEMBER': {
      return {
        ...state,
        staff_member_row: undefined,
        staff_member_id: undefined,
        staff_member_status: undefined
      };
    }
    case 'GET_STAFF_REWARDS_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        staffRewards: {
          ...state.staffRewards,
          stores: action.payLoad.data
        }
      };
    }
    case 'GET_STAFF_REWARDS_OUTLET_PENDING': {
      return {
        ...state,
        staffRewards: {
          ...state.staffRewards,
          manageFetching: true,
          manageFetched: false,
        }
      };
    }
    case 'GET_STAFF_REWARDS_OUTLET_FULFILLED': {
      return {
        ...state,
        staffRewards: {
          ...state.staffRewards,
          manageStoreId: action.payLoad.storeId,
          manageRow: action.payLoad.row,
          manageFetching: false,
          manageFetched: true,
          rewardMarkup: action.payLoad.rewardMarkup,
          availableVoucherTypes: action.payLoad.availableVoucherTypes,
          availableVoucherDenominations: action.payLoad.availableVoucherDenominations,
        }
      };
    }
    case 'SAVE_STAFF_REWARDS_FULFILLED': {
      return {
        ...state,
        staffRewards: {
          ...state.staffRewards,
          manageStoreId: null,
          manageRow: null,
          manageFetching: false,
          manageFetched: false,
          rewardMarkup: null,
          availableVoucherTypes: [],
          availableVoucherDenominations: [],
        }
      };
    }
    default:
  }

  return {...state};
}
